export default "__VITE_ASSET__BT3LdXLD__"